<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: Admin.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,   -->
<!-- propagated, or distributed without prior approval by ESA.               -->
<template>
  <div>
    <ul class="admin nav nav-tabs">
      <li class="nav-item">
        <a
          role="button"
          class="admin__datasets nav-link"
          :class="{ active: selected == 'datasets' }"
          @click="selectDatasets"
          >Datasets</a
        >
      </li>
      <li class="nav-item">
        <a
          role="button"
          class="admin__resource-types nav-link"
          :class="{ active: selected == 'resource_types' }"
          @click="selectResourceTypes"
          >Resource Types</a
        >
      </li>
      <li class="nav-item">
        <a
          role="button"
          class="admin__file-formats nav-link"
          :class="{ active: selected == 'file_formats' }"
          @click="selectFileFormats"
          >File Formats</a
        >
      </li>
      <li class="nav-item">
        <a
          role="button"
          class="admin__settings nav-link"
          :class="{ active: selected == 'settings' }"
          @click="selectSettings"
          >Settings</a
        >
      </li>
    </ul>
    <br />
    <settings
      v-if="this.selected == 'settings'"
      :dataElements="apiResponse"
      @getElements="getElements"
      @clearApiResponse="clearApiResponse"
    ></settings>
    <common-listing
      v-else
      :dataType="dataType"
      :dataElements="apiResponse"
      @getElements="getElements"
      :selectableColumns="selectableColumns"
      :sortableColumns="sortableColumns"
      :defaultSortColumn="defaultSortColumn"
      :catalogueFields="catalogueFields"
      :arrayFields="arrayFields"
      :enableEdition="true"
    ></common-listing>
  </div>
</template>

<script>
import CommonListing from '@/components/CommonListing.vue'
import Settings from '@/components/Settings.vue'
import * as datasets from '@/lib/datasets'
import * as resource_types from '@/lib/resource_types'
import * as file_formats from '@/lib/file_formats'
import * as api from '@/lib/api'

export default {
  name: 'admin',
  components: {
    CommonListing,
    Settings,
  },
  data() {
    return {
      selected: 'datasets', //Possible values: "datasets" or "resource_types"
      dataType: 'Dataset',
      apiResponse: null,
    }
  },
  computed: {
    selectableColumns() {
      return this.selected == 'datasets'
        ? datasets.getSelectableColumns()
        : this.selected == 'resource_types'
        ? resource_types.getSelectableColumns()
        : file_formats.getSelectableColumns()
    },
    // Define sortable columns and map label to field key for API
    catalogueFields() {
      return this.selected == 'datasets'
        ? datasets.getDataMapping()
        : this.selected == 'resource_types'
        ? resource_types.getDataMapping()
        : file_formats.getDataMapping()
    },
    // Define sortable columns and map label to field key for API
    sortableColumns() {
      return this.selected == 'datasets'
        ? datasets.sortableColumns()
        : this.selected == 'resource_types'
        ? resource_types.sortableColumns()
        : file_formats.sortableColumns()
    },
    defaultSortColumn() {
      return this.selected === 'datasets' ? 'Dataset' : 'Name'
    },
    arrayFields() {
      return this.selected == 'datasets'
        ? datasets.getArrayFields()
        : this.selected == 'resource_types'
        ? resource_types.getArrayFields()
        : file_formats.getArrayFields()
    },
  },
  methods: {
    async getElements(type, searchParams) {
      if (type === 'Dataset') {
        let response = await api.getDatasets(searchParams)
        this.$emit('finishLoading')
        // Create locally in frontend new field id so it is valid for both
        response.results = response.results.map((item) => {
          item.id = item.dataset_id
          return item
        })
        this.apiResponse = response
      } else if (type === 'Resource Type') {
        let response = await api.getResourceTypes(searchParams)
        if (response) this.$emit('finishLoading')
        // Create locally in frontend new field id so it is valid for both
        response.results = response.results.map((item) => {
          item.id = item.resource_type_id
          return item
        })
        console.log({ response })
        this.apiResponse = response
      } else if (type === 'File Format') {
        let response = await api.getFileFormats(searchParams)
        if (response) this.$emit('finishLoading')
        // Create locally in frontend new field id so it is valid for both
        response.results = response.results.map((item) => {
          item.id = item.file_format_id
          return item
        })
        console.log({ response })
        this.apiResponse = response
      } else if (type === 'aggregation-fields' || type === 'column-fields') {
        let response = await api.getElements(type, searchParams)
        if (response) this.$emit('finishLoading')
        console.log({ response })
        this.apiResponse = response
      }
    },
    selectDatasets() {
      if (this.selected != 'datasets') {
        this.apiResponse = null
        this.dataType = 'Dataset'
        this.selected = 'datasets'
      }
    },
    selectResourceTypes() {
      if (this.selected != 'resource_types') {
        this.apiResponse = null
        this.dataType = 'Resource Type'
        this.selected = 'resource_types'
      }
    },
    selectFileFormats() {
      if (this.selected != 'file_formats') {
        this.apiResponse = null
        this.dataType = 'File Format'
        this.selected = 'file_formats'
      }
    },
    selectSettings() {
      this.apiResponse = null
      this.selected = 'settings'
    },
    clearApiResponse() {
      this.apiResponse = null
    },
  },
}
</script>

<style lang="scss" scoped></style>
